import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePreorderEnabled } from '../../hooks/usePreorderEnabled';
import GameSchedule from './GameSchedule';

const GameScheduleGuard: React.FC = () => {
  const { enabledNewVersion } = usePreorderEnabled();

  if (!enabledNewVersion) {
    return <Navigate to="/order_history" replace />;
  }

  return <GameSchedule />;
};

export default GameScheduleGuard;
